import { Box, Typography, Button } from "@mui/material";
import { Computer } from "@mui/icons-material";
import { Modal } from "components/common/Modal";
import useUpdateAsset from "hooks/assets/useUpdateAsset";
import { useAlert } from "hooks/alerts/useAlert";
import { GridRowId } from "@mui/x-data-grid-pro";

interface NotFoundAssetModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  refetch: () => void;
  selectedAssetIds: GridRowId[];
  selectAllFlag: boolean;
}

export function NotFoundAssetModal({
  open,
  setOpen,
  refetch,
  selectedAssetIds,
  selectAllFlag,
}: NotFoundAssetModalProps) {
  const { notFoundAssets } = useUpdateAsset({ refetch });
  const { alertError, alertSuccess, alertWarning } = useAlert();
  const handleClick = () => {
    if (selectedAssetIds.length > 0 || selectAllFlag) {
      notFoundAssets(selectedAssetIds, selectAllFlag)
        .then((response) => {
          const skipped = response?.data?.skippedCount ?? 0;
          const updatedCount = response?.data?.updatedCount;
          const allSkipped =
            skipped > 0 &&
            (typeof updatedCount === "number"
              ? updatedCount === 0
              : !selectAllFlag && skipped >= selectedAssetIds.length);
          const devices = skipped === 1 ? "device was" : "devices were";
          const pronoun = skipped === 1 ? "it has" : "they have";
          if (allSkipped) {
            alertWarning(
              `No assets were marked as can't release. ${skipped} verified unenrolled ${devices} left unchanged because ${pronoun} no security lock.`
            );
          } else if (skipped > 0) {
            alertSuccess(
              `Marked the other assets as can't release. ${skipped} verified unenrolled ${devices} left unchanged because ${pronoun} no security lock.`
            );
          } else {
            alertSuccess("Successfully marked the asset/s as can't release.");
          }
          setOpen(false);
        })
        .catch(({ response: { data } }) => {
          if (data.errors) {
            alertError(`There was an error: ${data.errors}`);
          }
        });
    }
  };

  return (
    <Modal open={open} setOpen={setOpen}>
      <Box>
        <Box sx={{ textAlign: "center" }}>
          <Computer color="primary" sx={{ fontSize: "60px" }} />
          <Typography mt={1} variant="h5" component="h2" fontWeight={800}>
            Can’t release the assets?
          </Typography>
          <Typography mt={0.5} color="text.secondary">
            Are you having issues releasing the assets? Whatever the case may be, Revivn can take apart the device
            instead.
          </Typography>
          <Typography mt={0.5} color="text.secondary">
            Let us know if you would like us to proceed with parting the assets! (However, please note that devices that
            are taken apart are not eligible for earnings.)
          </Typography>

          <Box mt={3} sx={{ display: "flex", gap: 1, alignItems: "center", justifyContent: "center" }}>
            <Button
              variant="outlined"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button variant="contained" onClick={handleClick}>
              yes, mark the assets as can't be released
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
